export default "__VITE_ASSET__O4v_20A4__"